
import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { UserModel } from 'src/app/models/authentication/user.model';
import { QuotationChartModel } from 'src/app/models/charts/preliminaries/quotation-chart.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { QuotationImportModel } from 'src/app/models/imports/quotation-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { QuotationModel } from 'src/app/models/preliminaries/quotation.model';
import { QuotationsPrintResponse } from 'src/app/models/preliminaries/quotations-print-response';
import { QuotationPrintModel } from 'src/app/models/print/preliminaries/quotation-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { QuotationSelectionTableModel } from 'src/app/models/tables/preliminaries/quotation-selection-table.model';
import { QuotationTableModel } from 'src/app/models/tables/preliminaries/quotation-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class QuotationService {

  constructor(private _httpClient: HttpClient) { }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllClientsForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetAllClientsForSelect}`,);
  }

  getAllConstructionSitesForSelect(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetAllConstructionSitesForSelect}/${branchId}`);
  }

  getAllRejectConceptsForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetAllRejectConceptsForSelect}`);
  }

  getAllPricesListForSelect(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetAllPricesListForSelect}/${branchId}`);
  }

  getAllSellersForSelect(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetAllSellersForSelect}/${branchId}`);
  }

  getAllTypesBussinesses1ForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetAllTypesBussinesses1ForSelect}`);
  }

  getAllTypesBussinesses2ForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetAllTypesBussinesses2ForSelect}`);
  }

  getAllTypesEquipmentForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetAllTypesEquipmentForSelect}`);
  }

  getAllTypesQuotationsForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetAllTypesQuotationsForSelect}`);
  }

  getAllQuotationsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<QuotationTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<QuotationTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetAllQuotationsWithPagination}`,
      filters, { params: params }
    );
  }

  getBranchByIdForSelect(branchId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetBranchByIdForSelect}/${branchId}`);
  }

  getClientByIdForSelect(clientId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetClientByIdForSelect}/${clientId}`);
  }

  getConstructionSiteByIdForSelect(constructionSiteId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetConstructionSiteByIdForSelect}/${constructionSiteId}`);
  }

  getPricesListByIdForSelect(priceListId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetPricesListByIdForSelect}/${priceListId}`);
  }

  getQuotationTypeByIdForSelect(quotationTypeId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetQuotationTypeByIdForSelect}/${quotationTypeId}`);
  }

  getSellerByIdForSelect(sellerId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetSellerByIdForSelect}/${sellerId}`);
  }

  getTypesBussinessesByIdForSelect(conceptId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetTypesBussinessesByIdForSelect}/${conceptId}`);
  }

  getTypeEquipmentByIdForSelect(conceptId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetTypeEquipmentByIdForSelect}/${conceptId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetColumnsForGeneralConsultation}`);
  }

  getIndicatorsForGeneralConsultation(filters: ColumnResponseModel[]): Observable<QuotationChartModel> {
    return this._httpClient.post<QuotationChartModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetIndicatorsForGeneralConsultation}`,
      filters);
  }

  getQuotationById(quotationId: number): Observable<QuotationModel> {
    return this._httpClient.get<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetQuotationById}/${quotationId}`);
  }

  createQuotation(quotationModel: QuotationModel): Observable<QuotationModel> {
    return this._httpClient.post<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.CreateQuotation}`,
      quotationModel);
  }

  createOrdersFromQuotation(quotationId: number): Observable<Array<number>> {
    return this._httpClient.post<Array<number>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.CreateOrdersFromQuotationAsync}/${quotationId}`,
      null);
  }

  createQuotationsFromCostCenterPrices(companyId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.CreateQuotationsFromCostCenterPrices}/${companyId}`,
      null);
  }

  getNameCompanyForImplementQuotation(companyId: number): Observable<string> {
    return this._httpClient.get<string>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetNameCompanyForImplementQuotation}/${companyId}`);
  }

  updateQuotation(quotationContract: QuotationModel): Observable<QuotationModel> {
    return this._httpClient.put<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.UpdateQuotation}`,
      quotationContract);
  }

  deleteQuotation(quotationId: number): Observable<QuotationModel> {
    return this._httpClient.delete<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.DeleteQuotation}/${quotationId}`);
  }

  setStateQuotation(quotationId: number): Observable<QuotationModel> {
    return this._httpClient.put<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.SetStateQuotation}/${quotationId}`,
      null);
  }

  revertStateQuotation(quotationId: number): Observable<QuotationModel> {
    return this._httpClient.put<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.RevertStateQuotation}/${quotationId}`,
      null);
  }

  rejectQuotation(quotationModel: QuotationModel): Observable<QuotationModel> {
    return this._httpClient.put<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.RejectQuotation}`,
      quotationModel);
  }

  revertImplementQuotation(companyId: number): Observable<boolean> {
    return this._httpClient.delete<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.RevertImplementQuotation}/${companyId}`);
  }


  getQuotationByKeysAsync(branchId: number, consecutive: number): Observable<QuotationModel> {
    const params = new HttpParams()
      .set('branchId', branchId)
      .set('consecutive', consecutive);
    return this._httpClient.get<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetQuotationByKeys}`,
      { params: params });
  }

  getFirstQuotationByKeysAsync(branchId: number): Observable<QuotationModel> {
    return this._httpClient.get<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetFirstQuotationByKeys}/${branchId}`);
  }

  getLastQuotationByKeysAsync(branchId: number): Observable<QuotationModel> {
    return this._httpClient.get<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetLastQuotationByKeys}/${branchId}`);
  }

  getPreviusQuotationByKeysAsync(branchId: number, consecutive: number | null): Observable<QuotationModel> {
    let params = new HttpParams().set('branchId', branchId)
    if (consecutive !== null)
      params = params.set('consecutive', consecutive.toString());
    return this._httpClient.get<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetPreviusQuotationByKeys}`,
      { params: params });
  }

  getNextQuotationByKeysAsync(branchId: number, consecutive: number | null): Observable<QuotationModel> {
    let params = new HttpParams().set('branchId', branchId)
    if (consecutive !== null)
      params = params.set('consecutive', consecutive.toString());
    return this._httpClient.get<QuotationModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetNextQuotationByKeys}`,
      { params: params });
  }

  //Adjuntos
  attachFilesToQuotation(quotationId: number, files: FormData): Observable<Array<string>> {
    return this._httpClient.post<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.AttachFilesToQuotation}/${quotationId}`, files);
  }

  getFilesToQuotation(quotationId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetFilesToQuotation}/${quotationId}`);
  }

  downloadFileToQuotation(quotationId: number, file: string): Observable<HttpEvent<Blob>> {
    const itemFilterResponse = new ItemFilterModel("file", null, quotationId, file);
    return this._httpClient.request(new HttpRequest('POST', `${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.DownloadFileToQuotation}`,
      itemFilterResponse, { reportProgress: true, responseType: 'blob' }));
  }

  deleteFilesToQuotation(quotationId: number, file: string): Observable<Array<string>> {
    const itemFilterResponse = new ItemFilterModel("file", null, quotationId, file);
    return this._httpClient.post<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.DeleteFilesToQuotation}`,
      itemFilterResponse);
  }

  getPermission(userContract: UserModel): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetPermission}`,
      userContract
    );
  }

  getQuotationForPrintt(quotationId: number, versionId: number, swBreakdown: number): Observable<Array<QuotationsPrintResponse>> {
    const itemFilterResponse = [
      new ItemFilterModel("QuotationId", null, quotationId, ""),
      new ItemFilterModel("VersionId", versionId, null, ""),
      new ItemFilterModel("SwBreakdown", swBreakdown, null, "")
    ];

    return this._httpClient.post<Array<QuotationsPrintResponse>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetQuotationForPrint}`,
      itemFilterResponse
    );
  }

  getQuotationByKeysByPrint(versionId: number | null, branchId: number | null, consecutive: number | null, swBreakdown: boolean): Observable<QuotationPrintModel> {
    const params = new HttpParams()
      .set('versionId', versionId || 0)
      .set('branchId', branchId || 0)
      .set('consecutive', consecutive || 0)
      .set('swBreakdown', swBreakdown);
    return this._httpClient.get<QuotationPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetQuotationByKeysByPrintAsync}`,
      { params: params }
    );
  }

  getEmptyQuotationPrint(): Observable<QuotationPrintModel> {
    return this._httpClient.get<QuotationPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetEmptyQuotationPrint}`);
  }

  getQuotationsForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[], swMaintenance: boolean | null = null): Observable<PagedResponseModel<QuotationSelectionTableModel>> {
    let params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    if (swMaintenance !== null) params = params.set('swMaintenance', swMaintenance);
    return this._httpClient.post<PagedResponseModel<QuotationSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetQuotationsForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForQuotationSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.GetColumnsForQuotationSelectionAsync}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  importQuotations(quotationsImport: Array<QuotationImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.ImportQuotationsAsync}`, quotationsImport);
  }

  revertImportQuotation(branchId: number, typeId: number): Observable<LoadPreInvoicingModel> {
    return this._httpClient.delete<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.quotation.RevertImportQuotation}/${branchId}/${typeId}`);
  }
}
